<template>
  <div class="wrapper-contact">
    <form @submit.prevent="handleSubmit">
      <div class="mb-4">
        <label>{{ t('inquiry.title') }}</label>
        <select v-model="title" class="select-title form-control">
          <option value="" selected>{{ t('inquiry.select') }}</option>
          <option v-for="option in inquiryTypes" :key="option.value" :value="option.value">
            {{ t(option.label) }}
          </option>
        </select>
      </div>
      <div class="mb-4">
        <label>{{ t('inquiry.writer') }}</label>
        <input type="hidden" v-model="userId">
        <input type="text" :value="userName" class="form-control" disabled>
      </div>
      <div class="mb-4">
        <textarea 
          v-model="content"
          maxlength="100"
          class="content-send-chat form-control"
          rows="10"
          :placeholder="t('inquiry.placeholder')"
        ></textarea>
      </div>
      <div class="flex items-center gap-4 mx-auto justify-center w-full">
        <button 
          type="submit" 
          class="btn btn-danger"
          :disabled="isSubmitting || !isValid"
        >
          {{ t('common.submit') }}
        </button>
        <button 
          type="button" 
          class="btn btn-primary" 
          @click="handleBack"
        >
          {{ t('common.cancel') }}
        </button>
      </div>
    </form>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, getCurrentInstance } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const { proxy } = getCurrentInstance();

// Constants
const inquiryTypes = [
  { value: 'inquiry.types.deposit', label: 'inquiry.types.deposit' },
  { value: 'inquiry.types.withdrawal', label: 'inquiry.types.withdrawal' },
  { value: 'inquiry.types.other', label: 'inquiry.types.other' }
]

// State
const title = ref('')
const content = ref('')
const isSubmitting = ref(false)

// Computed
const userId = computed(() => proxy.$store.state.user.id)
const userName = computed(() => proxy.$store.state.user.username)
const isValid = computed(() => {
  return title.value && content.value.trim().length > 0
})

const handleSubmit = async () => {
  if (!isValid.value) return

  isSubmitting.value = true

  try {
    await proxy.$store.dispatch('postInquiry', {
      title: title.value,
      content: content.value,
    })
    resetForm()
    await proxy.$store.dispatch('fetchInquiries')
  } finally {
    isSubmitting.value = false
  }
}

const resetForm = () => {
  title.value = ''
  content.value = ''
}

const handleBack = () => {
  document.querySelector('.chatlist_tata').style.display = 'block'
  document.querySelector('.wrapper-contact').style.display = 'none'
}

// Lifecycle
onMounted(() => {
})
</script>

<style>
.wrapper-contact {
  padding: 1.5rem;
}

.content-send-chat {
  resize: vertical;
  min-height: 150px;
}

.btn {
  min-width: 120px;
}

@media (max-width: 768px) {
  .btn {
    min-width: 100px;
  }
}
</style>
